module.exports = __webpack_public_path__ + "static/media/help-icon-blue.bcf00a36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help-icon-blue.svg
// module id = 1106
// module chunks = 0